// extracted by mini-css-extract-plugin
module.exports = {"container":"Legal_container__-bOZB","return":"Legal_return__28nFJ","returnIcon":"Legal_returnIcon__2kLV6"};